import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Steps } from 'antd';
import PropertyActions, { PropertySelectors } from '@redux/PropertyRedux';
const { Step } = Steps;

function PropertySider(props) {
  const { setStep, currentStep, propertyId } = props;

  return (
    <Steps
      direction="vertical"
      current={currentStep}
      onChange={val => {
        setStep(val);
      }}
    >
      <Step title="Basic" description="Property details" />
      <Step title="Service" description="Service details" />
      <Step
        title="Pricing"
        description="Pricing details"
        disabled={!propertyId}
      />
    </Steps>
  );
}

PropertySider.propTypes = {
  currentStep: PropTypes.number,
  setStep: PropTypes.func,
  propertyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

const mapStateToProps = state => ({
  currentStep: PropertySelectors.selectCurrentStep(state)
});

const mapDispatchToProps = dispatch => ({
  setStep: step => {
    dispatch(PropertyActions.setPropertyStep(step));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertySider);
